import { Signal } from '@preact/signals'

import { Typography, Button, Modal, TextLink } from 'components/UI'

interface Props {
	memberUsername: Signal<string>
	isModalOpen: Signal<boolean>
	isRemoveMemberButtonDisabled: boolean
	isRemoveMemberButtonLoading: boolean
	onCloseRemoveMemberModal: () => void
	removeMember: () => void
}

const RemoveMemberModal = ({
	memberUsername,
	isModalOpen,
	isRemoveMemberButtonDisabled,
	isRemoveMemberButtonLoading,
	onCloseRemoveMemberModal,
	removeMember
}: Props) => (
	<Modal
		className='space-y-10 p-10'
		isOpen={isModalOpen.value}
		onCloseModal={onCloseRemoveMemberModal}
	>
		<Typography color='text-product' text='Remove Member' variant='h2' />

		<div>
			<Typography
				color='text-black-100'
				text='Are you sure you want to remove'
				variant='text1'
			/>
			<Typography
				color='text-black-100'
				text={`${memberUsername} from your Team?`}
				variant='text1'
			/>
		</div>

		<div class='flex justify-between'>
			<TextLink
				ariaLabel='Cancel'
				onClick={onCloseRemoveMemberModal}
				text='Cancel'
				variant='secondary'
			/>

			<Button
				disabled={isRemoveMemberButtonDisabled}
				isLoading={isRemoveMemberButtonLoading}
				onClick={removeMember}
				text='Remove'
				variant='error'
			/>
		</div>
	</Modal>
)

export { RemoveMemberModal }
